import React from 'react';
import styled from 'styled-components';
// DownArrow is an untyped .js import; resolves as any.
import DownArrow from 'icons/down-arrow';

interface SortState {
  columnName?: string;
  id?: string;
  desc?: boolean;
}

interface SortIconProps {
  sortState: SortState;
  columnName: string;
}

interface IconProps extends SortIconProps {
  size?: string;
}

const isSorted = ({ sortState, columnName }: SortIconProps): boolean =>
  sortState.columnName === columnName || sortState.id === columnName;

const Icon = styled(({ columnName, sortState, ...attrs }: IconProps) => <DownArrow {...attrs} />).attrs<IconProps>(
  ({ theme }) => ({
    size: theme.grid.units(0.8),
  }),
)`
  margin-left: ${({ theme }) => theme.grid.units(0.3)};
  margin-right: ${({ theme }) => theme.grid.units(-0.6)};
  color: ${(props) => props.theme.colors[isSorted(props) ? 'selected' : 'selectableDarkBg']};
  transform: rotate(${(props) => (isSorted(props) && props.sortState.desc ? 0 : '180deg')});
`;

const SortIcon = (props: SortIconProps): React.ReactElement => <Icon {...props} />;

export default SortIcon;
